const en = {
  common: {
    brand: 'NEXUS',
    discord: 'Discord',
    loading: 'Loading…',
    copyright: '© 2026 Vih\'s Studio. All rights reserved.',
    links: 'Links',
    community: 'Community',
    terms: 'Terms of Service',
    termsShort: 'Terms',
  },

  lang: {
    label: 'Language',
    choose: 'Choose language',
    current: 'Current language: {{lang}}',
  },

  nav: {
    home: 'Home',
    howToJoin: 'How to Join',
    download: 'Download',
    vip: 'VIP Plans',
    economy: 'Economy',
    team: 'Team',
    admin: 'Admin',
    login: 'Sign in',
    myAccount: 'My account',
    logout: 'Sign out',
    copyIp: 'Copy IP',
    copied: 'Copied',
    copyIpAria: 'Copy server IP',
    copiedAria: 'IP copied',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    accountOf: '{{name}}\'s account',
    accountFallback: 'Account',
    playerFallback: 'player',
    vipActive: 'VIP active',
    online: 'Online',
    notifications: 'Notifications',
    notificationsUnread: 'Notifications, {{count}} unread',
    unreadCount: '{{count}} unread',
    allCaughtUp: 'All caught up',
    markRead: 'Mark as read',
    notifWelcomeTitle: 'Account connected',
    notifWelcomeBody:
      'Hi, {{name}}. Open My account for VIP, payments, and status.',
    notifWelcomeTime: 'Now',
    notifVipExpiringTitle: 'VIP expiring soon',
    notifVipExpiringBody: '{{plan}} expires {{when}} ({{date}}).',
    notifVipExpiringToday: 'today',
    notifVipExpiringDays: 'in {{count}} day',
    notifVipExpiringDaysPlural: 'in {{count}} days',
    notifVipActiveTitle: 'VIP active',
    notifVipActiveBody: '{{plan}} valid until {{date}}.',
    notifVipInactiveTitle: 'No active VIP',
    notifVipInactiveBody:
      'Renew or subscribe to a plan to keep your server perks.',
    notifDiscordTitle: 'Discord community',
    notifDiscordBody: 'Stay up to date on events, updates, and staff support.',
  },

  status: {
    checking: 'Checking…',
    unavailable: 'Unavailable',
    online: 'Online',
    offline: 'Offline',
    players: 'players',
    ipLabel: 'Server IP',
    copy: 'Copy',
    copied: 'Copied!',
    copyAria: 'Copy server IP',
  },

  home: {
    title: 'Survive. Build. Dominate.',
    lead:
      'Vanilla with the right plugins — economy, clans, and events in a community that plays for real.',
    downloadLauncher: 'Download Launcher',
    joinDiscord: 'Join Discord',
    howToJoin: 'How to join',
    worldTitle: 'A world built to last',
    worldLead: 'Stable infrastructure, systems that matter, and zero fluff.',
    worldStableTitle: 'Stable server',
    worldStableBody:
      'Low latency and constant uptime so you can focus on what matters: playing.',
    worldEconomyTitle: 'Living economy',
    worldEconomyBody:
      'Shops, markets, and real progression paths — without chaotic inflation.',
    worldClansTitle: 'Clans & territory',
    worldClansBody:
      'Gather allies, protect what\'s yours, and contest the map with strategy.',
    worldEventsTitle: 'Weekly events',
    worldEventsBody:
      'Competitions and exclusive rewards to keep the server hot.',
    joinTitle: 'How to join',
    joinLead: 'Four steps. You\'ll be on the server in minutes.',
    joinNote: 'Confirm the official IP on Discord — it may be updated.',
    step1Title: 'Join Discord',
    step1Body: 'Get rules, the official IP, and talk to the staff.',
    step2TitleDownload: 'Download Nexus Client',
    step2TitleMinecraft: 'Open Minecraft',
    step2BodyDownload:
      'Install the official launcher and sign in with Microsoft or offline.',
    step2BodyMinecraft: 'Java Edition 1.20.x or newer.',
    step3TitleDownload: 'Click Play',
    step3TitleMinecraft: 'Add the server',
    step3BodyDownload:
      'The Client installs Java if needed and connects to Origins.',
    step3BodyMinecraft: 'Paste the IP into the multiplayer list and save.',
    step4Title: 'Join and play',
    step4Body: 'Explore, build, and find your crew.',
    ctaTitle: 'Ready to spawn?',
    ctaLeadDownload: 'Download the Nexus Client and start your season on the server.',
    ctaLeadDiscord:
      'Join Discord, grab the IP, and start your season on Nexus.',
    vipPlans: 'VIP Plans',
    footerBrand:
      'Vanilla with plugins, economy, clans, and events. Community first.',
  },

  download: {
    kicker: 'Official launcher',
    title: 'Client',
    lead:
      'Join Nexus Origins in one click. Microsoft and offline accounts, automatic updates, and Java install when needed.',
    downloadWindows: 'Download for Windows',
    metaBase: 'Windows 10/11',
    metaInstaller: 'Installer ~6 MB',
    whyTitle: 'Why use the Client',
    whyLead: 'Built for the Nexus Network — less setup, more play.',
    featFastTitle: 'Fast entry',
    featFastBody:
      'Play on Origins without fiddling with a generic launcher profile.',
    featUpdateTitle: 'Automatic updates',
    featUpdateBody:
      'When a new version ships, the launcher notifies and updates — no re-downloading the setup.',
    featSecureTitle: 'Secure accounts',
    featSecureBody:
      'Microsoft login (online-mode) or offline account for the Nexus server.',
    startTitle: 'How to start',
    startLead: 'Three steps and you\'re at spawn.',
    start1Title: 'Download and install',
    start1Body: 'Run the Windows installer and open Nexus Client.',
    start2Title: 'Sign in with your account',
    start2Body: 'Microsoft or offline nick — the active account is used in-game.',
    start3Title: 'Click Play',
    start3Body: 'The Client handles Java and connects to Origins automatically.',
    ctaTitle: 'Ready to play?',
    ctaLead: 'Download the official launcher and join the Nexus season.',
    ctaDownload: 'Download Nexus Client',
    ctaVip: 'View VIP plans',
    footerBrand: 'Official launcher of the Nexus Network / Vih\'s Studio.',
  },

  error404: {
    kicker: 'Chunk failed to load',
    title: 'Page not found',
    lead:
      'That path isn\'t on the Nexus map. Head back to spawn or ping the crew on Discord.',
    backHome: 'Back to home',
  },

  comingSoon: {
    kicker: 'Coming soon',
    title: 'The server is almost ready',
    lead:
      'We\'re finishing the site and the experience. Join Discord to follow the launch, grab the IP, and be part of the community from day one.',
    joinDiscord: 'Join Discord',
    staffAccess: 'Staff access',
  },
};

export default en;
